module.exports = __webpack_public_path__ + "static/media/toggle.44815965.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/toggle.svg
// module id = 997
// module chunks = 0